import { useContext, useEffect, useState } from "react";
import { Props } from "./AccordionDetailsProps";
import MainContext from "../../../context/mainContext";
import { ISummaryFinalVersionModel } from "../../../models/summary.model";
import summaryService from "../../../services/summary.service";
import SpinnerArea from "../../../components/SpinnerArea";
import { Box } from "@mui/material";
import styles from "./AccordionDetails.module.scss";
import DocumentView from "../../../components/DocumentView";
import Empty from "./Empty";
import { t } from "i18next";

const SummaryFinalVersion: React.FC<Props> = ({ publicationId, expanded }) => {
  const { service } = useContext(MainContext);
  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [finalVersions, setFinalVersions] = useState<ISummaryFinalVersionModel[]>();

  useEffect(() => {
    let active = true;

    if (active && expanded && !loaded) {
      service(() => summaryService.finalVersion(publicationId), {
        loader: setLoading,
        callback: (data) => {
          setFinalVersions(data);
          setLoaded(true);
        },
      });
    }

    return () => {
      active = false;
    };
  }, [expanded, loaded, publicationId, service]);

  return (
    <SpinnerArea loading={loading}>
      {finalVersions && finalVersions.length > 0 ? (
        <Box className={styles.finalVersion}>
          <DocumentView document={finalVersions} showVersion hideOpenOnline />
        </Box>
      ) : (
        <Empty messge={t("youDontHaveAnyFinalVersionYet")} />
      )}
    </SpinnerArea>
  );
};

export default SummaryFinalVersion;
